module.exports = __webpack_public_path__ + "static/media/dream.42530f0b.wav";